import './css/app.css';
import pageLoader from './js/components/pageLoader';
import mobileMenu from './js/components/mobileMenu';
import header from './js/components/header';
import lookSlider from './js/components/look-slider';
import getThisLook from './js/components/get-this-look';
import featuredContentSection from './js/components/featuredContentSection';
import reviewsSlider from './js/components/reviewsSlider';
import media from './js/components/media';
import collectionFilter from './js/components/collectionFilter';
import collectionFilterMobile from './js/components/collectionFilterMobile';
import accordion from './js/components/accordion';
import textLinkImageVideo from './js/components/textLinkImageVideo';
import modalVideo from './js/components/modalVideo';
import collectionSlider from './js/components/collectionSlider';
import shippingToday from './js/components/shippingToday';
import faqGroupHeader from './js/components/faqGroupHeader';
import productCard from './js/components/productCard';
import generalSlider from './js/components/generalSlider';
import productDescription from './js/components/productDescription';
import productImageCarousel from './js/components/product-image-carousel';
import colorSelect from './js/components/colorSelect';
import productCarousel from './js/components/productCarousel';
import searchComponent from './js/components/search';
import gramTabNavigation from './js/components/gram-tab-navigation';
import wearSlider from './js/components/wearSlider';
import buttonAddToCart from './js/components/button-add-to-cart';
import relatedArticleCarousel from './js/components/relatedArticleCarousel';
import courseMethodCarousel from './js/components/courseMethodCarousel';
import cartDrawer from './js/components/cart-drawer';
import buyItWith from './js/components/buyItWith';
import sizeSelect from './js/components/sizeSelect';
import textureSelect from './js/components/textureSelect';
import courseCarousel from './js/components/courseCarousel';
import customerMenu from './js/components/customerMenu';
import mainAccount from './js/components/mainAccount';
import accountHeader from './js/components/accountHeader';
import mainCourse from './js/components/mainCourse';
import mainOrder from './js/components/mainOrder';
import courseVideo from './js/components/courseVideo';
import sliderContentOptional from './js/components/sliderContentOptional';
import languageCurrencySelector from './js/components/languageCurrencySelect';
import desktopMenu from './js/components/desktopMenu';
import desktopMenuMega from './js/components/desktopMenuMega';
import megaMenuSlider from './js/components/megaMenuSlider';
import loginAccountFormSimplified from './js/components/loginAccountFormSimplified';
import lengthGuideModal from './js/components/length-guide-modal';
import howToSelectModal from './js/components/how-to-select-modal';
import searchResultsForm from './js/components/searchResultsFormBar';
import resourceAccess from './js/components/resourceAccess';
import simpleVariantSelect from './js/components/simpleVariantSelect';
import addToCartPopup from './js/components/add-to-cart-popup';
import getCoursesData from './js/components/getCoursesData';
import quickAddToCart from './js/components/quick-add-to-cart';
import customOrderForm from './js/components/custom-order-form';
import announcementBanner from './js/components/announcement-banner';
import reelsSlider from './js/components/reelsUgcSlider';
import pairItWith from './js/components/pair-it-with';
import cartChatters from './js/components/cart-chatters';
import chattersProductCard from './js/components/chatters-product-card';
import animationSections from './js/components/animation-sections';
import countdownTimer from './js/components/countdown-timer';
import textureGuideModal from './js/components/texture-guide-modal';

const componentsMap = {
  cartChatters,
  countdownTimer,
  quickAddToCart,
  animationSections,
  getCoursesData,
  addToCartPopup,
  simpleVariantSelect,
  resourceAccess,
  howToSelectModal,
  lengthGuideModal,
  desktopMenuMega,
  megaMenuSlider,
  desktopMenu,
  buyItWith,
  cartDrawer,
  courseCarousel,
  courseVideo,
  mainOrder,
  mainCourse,
  accountHeader,
  mainAccount,
  customerMenu,
  buttonAddToCart,
  media,
  getThisLook,
  wearSlider,
  shippingToday,
  faqGroupHeader,
  generalSlider,
  productDescription,
  accordion,
  collectionFilterMobile,
  collectionFilter,
  modalVideo,
  textLinkImageVideo,
  collectionSlider,
  reviewsSlider,
  featuredContentSection,
  pageLoader,
  mobileMenu,
  header,
  lookSlider,
  productCard,
  productImageCarousel,
  colorSelect,
  productCarousel,
  searchComponent,
  courseMethodCarousel,
  gramTabNavigation,
  relatedArticleCarousel,
  sizeSelect,
  textureSelect,
  sliderContentOptional,
  loginAccountFormSimplified,
  languageCurrencySelector,
  searchResultsForm,
  customOrderForm,
  announcementBanner,
  reelsSlider,
  pairItWith,
  textureGuideModal,
  chattersProductCard,
};

const mountComponents = () => {
  const components = document.querySelectorAll('[data-component]');

  components.forEach((el) => {
    const component = el.dataset.component;

    if (componentsMap[component]) {
      componentsMap[component](el);
    }
  });
};

const mountAccordions = (e) => {
  let component = null;
  // mobile slider
  const accordionComponent = e.detail.node;
  if (accordionComponent) {
    component = accordionComponent.dataset.component;
    if (componentsMap[component]) {
      componentsMap[component](accordionComponent);
    }
  }
};

const mountProductCard = (e) => {
  let component = null;
  // mobile slider
  const productCard = e.detail.node;
  if (productCard) {
    component = productCard.dataset.component;
    if (componentsMap[component]) {
      componentsMap[component](productCard);
    }
  }
};

const mountCoursesVideos = (e) => {
  let component = null;
  // mobile slider
  const courseVideoComponent = e.detail.node;
  if (courseVideoComponent) {
    component = courseVideoComponent.dataset.component;
    if (componentsMap[component]) {
      componentsMap[component](courseVideoComponent);
    }
  }
};

document.addEventListener('DOMContentLoaded', () => {
  mountComponents();
});
document.addEventListener('shopify:section:load', () => {
  mountComponents();
});
document.addEventListener('shopify:section:load:accordion', mountAccordions);
document.addEventListener(
  'shopify:section:load:product-card',
  mountProductCard
);
document.addEventListener(
  'shopify:section:load:course-videos',
  mountCoursesVideos
);

// event listener for rebuy add event, then we can update the cart and open the cart drawer
document.addEventListener('rebuy.add', function (event) {
  document.dispatchEvent(new CustomEvent('cart:updated'));
});
